export default __webpack_public_path__ + "static/media/cal_bg1.73795a79.jpg";